module.exports = __webpack_public_path__ + "img/logo.671a38ab.png";